import type { ReactNode } from 'react';
import type { AgentAccessScope, AgentRecordContext } from '@cdf/api-client-react';
import { AgentAttachments } from './agent-attachments';
import { useAgentAttachments, type AgentAttachmentsController } from './use-agent-attachments';

type Props = { identity: string; context: AgentRecordContext; threadId: string; disabled: boolean; composerPlacement?: boolean; children: (files: AgentAttachmentsController) => ReactNode };
/** Keying the whole file session disposes pending reads, selection, queries and downloads on every audience change. */
export function SharedAttachmentSession(props: Props) {
  const { context, identity, threadId } = props;
  return <SharedAttachmentSessionBody key={JSON.stringify([identity, context.tenantId, context.entityId, context.kind, context.recordId, threadId])} {...props} />;
}
function SharedAttachmentSessionBody({ identity, context, threadId, disabled, children, composerPlacement = false }: Props) {
  const scope: AgentAccessScope = { kind: 'entity', tenantId: context.tenantId, entityId: context.entityId };
  const files = useAgentAttachments({ identity, scope, conversationId: threadId, eligible: !disabled, sharedContext: context, onConversation: () => undefined });
  return <>
    {!composerPlacement && <AgentAttachments controller={files} conversationId={threadId} scope={scope} identity={identity} disabled={disabled} />}
    {children(files)}
  </>;
}
